import { CartAddEvent } from '@theme/events';
import Swiper from 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';
if (!customElements.get('cabinet-configurator')) {
  customElements.define(
    'cabinet-configurator',
    class CabinetConfigurator extends HTMLElement {
      constructor() {
        super();
        this.isLoading = false;
        this.loader = this.querySelector('[data-configurator-loader]');
        this.stickyPanel = this.querySelector('[data-sticky-panel]');
        this.cabinetConfiguratorProduct = document.querySelector('cabinet-featured-product');
        this.properties = [
          {
            attribute: 'data-has-colors',
            filter: 'filter.p.m.custom.finish_color',
            filterName: 'data-filter-color',
            inputRef: 'ref="colorProperty"',
            value: 'data-color',
            prevValue: 'data-prev-color',
          },
          {
            attribute: 'data-has-door-style',
            filterName: 'data-filter-door-style',
            filter: 'filter.p.m.custom.door_style',
            inputRef: 'ref="doorStyleProperty"',
            value: 'data-door-style',
            prevValue: 'data-prev-door-style',
          },
          {
            attribute: 'data-has-edge-profile',
            filterName: 'data-filter-edge-profile',
            filter: 'filter.p.m.custom.door_edge_profile',
            inputRef: 'ref="doorEdgeProfileProperty"',
            value: 'data-edge-profile',
            prevValue: 'data-prev-edge-profile',
          },
          {
            attribute: 'data-has-boxcolor',
            filterName: 'data-filter-boxcolor',
            filter: 'filter.p.m.custom.drawer_box_color',
            inputRef: ' ref="drawerBoxColorProperty"',
            value: 'data-boxcolor',
            prevValue: 'data-prev-boxcolor',
          },
        ];
      }
      get currentFilterUrl() {
        return this.dataset.filterUrl;
      }

      connectedCallback() {
        this.setInitialProperties();
        this.setCategoryFilters();
        this.attachListeners();
        this.handleStickyPanel();
        this.hadleOrderSample();

        document.addEventListener('filters::updated', () => {
          this.attachListeners();
          for (let i = 0; i < this.properties.length; i++) {
            if (this.getAttribute(`${this.properties[i].value}`) !== '') {
              this.setProperty(
                `${this.properties[i]?.inputRef}`,
                this.getAttribute(`${this.properties[i].value}`),
                `${this.properties[i]?.value}`
              );
            }
          }
        });
      }

      attachListeners() {
        this.setPropertyFilters();
        this.setSubCategoryFilters();
        this.setConfigurationsButtons();
        this.setPagination();
        this.setFilterButton();
        this.toggleProperties();
        this.handleToggleOutsideElement();
        this.calculateToggleWidth();
        this.handleImageAddToCart();
      }
      showLoader() {
        this.isLoading = true;
        this.classList.add('loading');

        if (this.loader) {
          this.loader.classList.add('active');
        }
      }

      hideLoader() {
        this.isLoading = false;
        this.classList.remove('loading');

        if (this.loader) {
          this.loader.classList.remove('active');
        }
      }

      setInitialProperties() {
        for (let i = 0; i < this.properties.length; i++) {
          const activeProperty = this.querySelector(`[${this.properties[i]?.filterName}].active`);
          if (activeProperty) {
            this.setProperty(
              `${this.properties[i]?.inputRef}`,
              activeProperty.dataset.value,
              `${this.properties[i]?.value}`
            );
            this.filterBy(activeProperty, false, true);
          }
        }
        this.applyFilter();
      }

      setPropertyFilters() {
        for (let i = 0; i < this.properties.length; i++) {
          const filters = this.querySelectorAll(`[${this.properties[i]?.filterName}]`);
          if (filters.length > 0) {
            filters.forEach((filter) =>
              filter.addEventListener('click', () => {
                filters.forEach((el) => el.classList.remove('active'));
                filter.classList.add('active');
                this.setProperty(
                  `${this.properties[i]?.inputRef}`,
                  filter.dataset.value,
                  `${this.properties[i]?.value}`
                );
                this.setAttribute(`${this.properties[i]?.prevValue}`, filter.dataset.value);
                this.setActiveProperty(filter);
                this.filterBy(filter);
              })
            );
          }
        }
      }

      setCategoryFilters() {
        const filters = this.querySelectorAll('[data-filter-category]');
        if (filters.length === 0) return;
        filters.forEach((filter) =>
          filter.addEventListener('click', () => {
            filters.forEach((currentFilter) => currentFilter.classList.remove('active'));
            filter.classList.add('active');
            this.filterBy(filter);
          })
        );
      }

      setSubCategoryFilters() {
        const filters = this.querySelectorAll('[data-filter-subcategory]');
        if (filters.length === 0) return;
        filters.forEach((filter) =>
          filter.addEventListener('click', () => this.filterBy(filter, true))
        );
      }

      filterBy(filter, multichoice = false, prepareOnly = false) {
        const filterParamName = filter.dataset.filterParam;
        const filterValue = filter.dataset.value;
        let url = new URL(window.location.href);

        if (this.currentFilterUrl !== '') {
          url = new URL(this.currentFilterUrl);
        }

        if (!multichoice) {
          filter.hasAttribute('data-reset')
            ? url.searchParams.delete(filterParamName)
            : url.searchParams.set(filterParamName, filterValue);
        } else {
          const currentValues = url.searchParams.getAll(filterParamName);
          if (filter.hasAttribute('data-reset')) {
            const values = currentValues.filter((value) => value !== filterValue);
            url.searchParams.delete(filterParamName);
            values.forEach((value) => url.searchParams.append(filterParamName, value));
          } else {
            if (!currentValues.includes(filterValue)) {
              url.searchParams.append(filterParamName, filterValue);
            }
          }
        }

        if (filter.hasAttribute('data-filter-to-update')) {
          const filtersToUpdate = filter.dataset?.filterToUpdate?.split(',');
          if (filtersToUpdate.length > 0) {
            filtersToUpdate.forEach((item) => {
              url.searchParams.delete(item);
            });
          }
        }
        const hasProperties =
          filter.hasAttribute('data-has-colors') ||
          filter.hasAttribute('data-has-door-style') ||
          filter.hasAttribute('data-has-edge-profile') ||
          filter.hasAttribute('data-has-boxcolor') ||
          filter.hasAttribute('data-has-properties');

        if (hasProperties) {
          for (let i = 0; i < this.properties.length; i++) {
            const hasProperties =
              filter.getAttribute(`${this.properties[i]?.attribute}`) === 'true';
            if (!hasProperties) {
              url.searchParams.delete(`${this.properties[i]?.filter}`);
              this.setAttribute(
                `${this.properties[i]?.prevValue}`,
                this.getAttribute(`${this.properties[i]?.value}`)
              );
              this.setAttribute(`${this.properties[i]?.value}`, '');
            } else {
              if (this.hasAttribute(`${this.properties[i]?.prevValue}`)) {
                url.searchParams.set(
                  `${this.properties[i]?.filter}`,
                  this.getAttribute(`${this.properties[i]?.prevValue}`)
                );
                this.setAttribute(
                  `${this.properties[i]?.value}`,
                  this.getAttribute(`${this.properties[i]?.prevValue}`)
                );
              }
            }
          }
        }
        url.searchParams.delete('page');
        this.dataset.filterUrl = url.toString();
        if (!prepareOnly) {
          this.applyFilter();
        }
      }

      async applyFilter() {
        if (this.isLoading) return;

        this.showLoader();

        try {
          const response = await fetch(this.currentFilterUrl);

          const result = await response.text();

          const HTML = new DOMParser().parseFromString(result, 'text/html');

          const elementsToRerender = this.querySelectorAll('[data-should-rerender]');

          elementsToRerender.forEach((element) => {
            const rerenderValue = element.dataset.shouldRerender;

            const newElement = HTML.querySelector(`[data-should-rerender="${rerenderValue}"]`);

            if (newElement) {
              element.innerHTML = newElement.innerHTML;
            }
          });

          document.dispatchEvent(new CustomEvent('filters::updated'));
        } catch (error) {
          if (error.name !== 'AbortError') {
            console.error(error);
          }
        } finally {
          this.scrollToTop();
          this.hideLoader();
        }
      }

      setProperty(name, value, attribute) {
        const properties = this.querySelectorAll(`[${name}]`);
        if (properties.length === 0) return;
        this.setAttribute(`${attribute}`, value);
        properties.forEach((property) => (property.value = value));
      }

      toggleProperties() {
        const toggles = this.querySelectorAll('[data-dropdown-toggle]');
        if (toggles.length === 0) return;
        toggles.forEach((toggle) => {
          const key = toggle.dataset.dropdownToggle;
          const body = this.querySelector(`[data-dropdown="${key}"]`);
          if (!body) return;
          toggle.addEventListener('click', () => {
            body.classList.toggle('open');
          });
        });
      }

      setActiveProperty(filter) {
        const key = filter.dataset.filterParam;
        const parent = this.querySelector(`[data-dropdown-toggle="${key}"]`);
        const parentBody = this.querySelector(`[data-dropdown="${key}"]`);
        if (!parent) return;
        const parentValue = parent.querySelector('[data-current-value]');
        if (!parentValue) return;
        parentValue.innerHTML = filter.dataset.value;
        if (filter.hasAttribute('data-filter-color')) {
          parent.style.setProperty('--cabinet-color', filter.dataset.colorCode);
        }
        if (!parentBody) return;
        setTimeout(() => {
          parentBody.classList.remove('open');
        }, 200);
      }

      setConfigurationsButtons() {
        const configurationButtons = document.querySelectorAll('[data-add-configuration]');
        if (configurationButtons.length === 0) return;
        configurationButtons.forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const popupId = button.dataset.addConfiguration;
            const popup = this.querySelector(`[data-popup-id="${popupId}"]`);
            if (!popup) return;
            const productCard = this.querySelector(`product-card[data-product-id="${popupId}"]`);
            if (!productCard) return;
            const quantityEl = productCard.querySelector('[ref="quantityInput"]');
            const quantity = quantityEl ? Number(quantityEl.value) : 1;
            const quantityContainer = popup.querySelector('[data-selected-quantity]');
            popup.dataset.productQuantity = quantity;
            if (quantityContainer) {
              quantityContainer.innerHTML = `(${quantity})`;
            }
            popup.classList.add('active');
            document.body.classList.add('overflow-hidden');
          });
        });
      }

      setFilterButton() {
        const openButton = this.querySelector('[data-open-filters-popup]');
        const filtersPopup = this.querySelector('cabinet-configurator-filters');
        if (!openButton || !filtersPopup) return;
        openButton.addEventListener('click', () => {
          filtersPopup.classList.add('active');
          this.classList.add('filters-opened');
          document.body.classList.add('overflow-hidden');
        });
      }

      setPagination() {
        const pagintationButtons = this.querySelectorAll('.pagination__item a');
        if (pagintationButtons.length === 0) return;
        pagintationButtons.forEach((button) =>
          button.addEventListener('click', (event) => {
            event.preventDefault();
            let url = new URL(window.location.href);

            if (this.currentFilterUrl !== '') {
              url = new URL(this.currentFilterUrl);
            }
            const pageUrl = new URL(button?.href);
            const page = pageUrl.searchParams.get('page');
            url.searchParams.set('page', page);
            this.dataset.filterUrl = url.toString();
            this.applyFilter();
          })
        );
      }

      handleStickyPanel() {
        if (!this.stickyPanel) return;
        this.lastScrollTop = 0;
        this.ticking = false;

        window.addEventListener('scroll', () => {
          if (!this.ticking) {
            window.requestAnimationFrame(() => {
              this.handleScroll();
            });

            this.ticking = true;
          }
        });
      }

      handleScroll() {
        const scrollTop = window.pageYOffset;
        const scrollingDown = scrollTop > this.lastScrollTop;
        const sectionBottom =
          document.querySelector('header')?.clientHeight + this.stickyPanel.clientHeight + 75;
        const stopSticky = this.getBoundingClientRect().bottom <= sectionBottom;
        if (scrollTop <= 0 || stopSticky) {
          this.stickyPanel.classList.remove('is-sticky');
        } else if (scrollingDown && !stopSticky) {
          this.stickyPanel.classList.add('is-sticky');
        } else {
          this.stickyPanel.classList.remove('is-sticky');
        }

        this.lastScrollTop = scrollTop;
        this.ticking = false;
      }

      hadleOrderSample() {
        if (!this.cabinetConfiguratorProduct) return;
        let scroll = false;
        const orderSampleButton =
          this.cabinetConfiguratorProduct.querySelector('[data-order-sample]') ||
          this.cabinetConfiguratorProduct.querySelector('a[href="#sample]');
        const sampleFilter = this.querySelector('[data-sample-category]');
        const sampleSubfilter = this.querySelector('[data-sample-subcategory]');

        orderSampleButton.addEventListener('click', (event) => {
          event.preventDefault();
          this.isLoading = false;
          if (sampleFilter) {
            sampleFilter.click();
            scroll = true;
          } else if (sampleFilter && sampleSubfilter) {
            sampleFilter.click();
            scroll = true;
          } else {
            sampleSubfilter.click();
            scroll = true;
          }
          if (scroll) {
            setTimeout(() => {
              window.scrollTo({
                top: this.getBoundingClientRect().top,
                behavior: 'smooth',
              });
            }, 1000);
          }
        });
      }

      handleToggleOutsideElement() {
        const dropdownElements = this.querySelectorAll('[data-dropdown]');
        if (dropdownElements.length === 0) return;
        document.addEventListener('click', (event) => {
          const path = event.composedPath();
          dropdownElements.forEach((dropdown) => {
            const trigger = this.querySelector(
              `[data-dropdown-toggle="${dropdown.dataset.dropdown}"]`
            );
            if (!path.includes(dropdown) && !path.includes(trigger)) {
              dropdown.classList.remove('open');
            }
          });
        });
      }

      calculateToggleWidth() {
        const dropdownElements = this.querySelectorAll('[data-dropdown]');
        if (dropdownElements.length === 0) return;
        dropdownElements.forEach((dropdown) => {
          dropdown.style.width = dropdown.clientWidth + 'px';
        });
      }

      handleImageAddToCart() {
        const imageAddToCart = this.querySelectorAll('[data-use-image-add-to-cart]');
        if (imageAddToCart.length === 0) return;
        imageAddToCart.forEach((image) => {
          image.addEventListener('click', () => {
            const parent = image.closest('product-card');
            if (parent) {
              const addToCartButton = parent.querySelector('[ref="addToCartButton"]');
              if (addToCartButton) addToCartButton.click();
            }
          });
        });
      }

      scrollToTop() {
        if (!this.currentFilterUrl.includes('page=')) return;
        const storeHeader = document.querySelector('header');
        const start = window.scrollY + this.getBoundingClientRect().top - storeHeader?.clientHeight;
        window.scrollTo({
          top: start,
          behavior: 'smooth',
        });
      }
    }
  );
}

if (!customElements.get('cabinet-configuration-popup')) {
  customElements.define(
    'cabinet-configuration-popup',
    class CabinetConfigurationPopup extends HTMLElement {
      constructor() {
        super();
      }

      get popupId() {
        return this.dataset.popupId;
      }

      get productId() {
        return this.dataset.productId;
      }

      get groupId() {
        if (!this.hasAttribute('data-group-id')) return null;
        return this.dataset.groupId;
      }

      get updatesPayload() {
        if (!this.hasAttribute('data-updates')) return null;
        return JSON.parse(atob(this.dataset.updates));
      }

      get properties() {
        if (!this.hasAttribute('data-properties')) return null;
        return JSON.parse(atob(this.dataset.properties));
      }

      get productTitle() {
        return this.dataset.productTitle;
      }

      get size() {
        return Number(this.dataset.size);
      }

      get currency() {
        return this.dataset.currency;
      }

      connectedCallback() {
        this.cabinetConfigurator = this.closest('cabinet-configurator');
        this.addToCartButton = this.querySelector('[data-add-to-cart-selection]');
        this.updateSelectionButton = this.querySelector('[data-update-selection]');
        this.hingeButtons = this.querySelectorAll('[data-hinge-side]');
        this.finishedButtons = this.querySelectorAll('[data-finished-end]');
        this.closeButtons = this.querySelectorAll('[data-close-popup]');
        this.priceContainer = this.querySelector('[data-selected-price]');
        this.quantityContainer = this.querySelector('[data-selected-quantity]');

        if (this.hingeButtons.length > 0) {
          this.hingeButtons.forEach((button) => {
            button.addEventListener('click', () => this.setActive(this.hingeButtons, button));
          });
        }

        if (this.finishedButtons.length > 0) {
          this.finishedButtons.forEach((button) => {
            button.addEventListener('click', () => this.setActive(this.finishedButtons, button));
          });
        }

        if (this.addToCartButton) {
          this.addToCartButton.addEventListener('click', (event) => this.handleAddToCart(event));
        }

        if (this.closeButtons.length > 0) {
          this.closeButtons.forEach((button) => {
            button.addEventListener('click', () => {
              this.classList.remove('active');
              if (this.parentNode && this.parentNode.tagName === 'DIALOG') this.parentNode.close();
              document.body.classList.remove('overflow-hidden');
            });
          });
        }

        if (this.updateSelectionButton) {
          this.updateSelectionButton.addEventListener('click', (event) =>
            this.updateSelection(event)
          );
        }
      }

      setActive(buttons, element) {
        const option1Error = this.querySelector('[data-hinge-error]');
        const option2Error = this.querySelector('[data-finished-end-error]');
        buttons.forEach((button) => button.classList.remove('active'));
        element.classList.add('active');

        if (element.hasAttribute('data-hinge-side')) {
          option1Error.classList.remove('active');
        } else {
          option2Error.classList.remove('active');
        }

        this.setPrice(element);
        this.adjustQuantity(element);
      }

      async handleAddToCart(event) {
        event.preventDefault();
        event.stopPropagation();
        const activeOptions = this.querySelectorAll('[data-option].active');
        if (activeOptions.length !== this.size) {
          const option1Active = this.querySelector('[data-hinge-side].active');
          const option2Active = this.querySelector('[data-finished-end].active');

          const option1Error = this.querySelector('[data-hinge-error]');
          const option2Error = this.querySelector('[data-finished-end-error]');

          if (!option1Active && option1Error) {
            option1Error.classList.add('active');
          }
          if (!option2Active && option2Error) {
            option2Error.classList.add('active');
          }
          return;
        }

        const payload = this.preparePayload(activeOptions) || {};
        const request = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        };
        try {
          if (this.updateSelectionButton) {
            this.updateSelectionButton.setAttribute('data-added', true);
          }
          if (this.addToCartButton) {
            this.addToCartButton.setAttribute('data-added', true);
          }
          const response = await fetch(Theme.routes.cart_add_url, request);
          const result = await response.json();
          this.dispatchEvent(
            new CartAddEvent({}, this.productId, {
              source: 'product-form-component',
              itemCount:
                payload.items.length === 2 ? payload.items[1].quantity : payload.items[0].quantity,
              productId: this.popupId,
              sections: result.sections,
            })
          );
        } catch (error) {
          console.error(error);
        } finally {
          if (this.addToCartButton) {
            setTimeout(() => {
              this.addToCartButton.removeAttribute('data-added');
              this.classList.remove('active');
              document.body.classList.remove('overflow-hidden');
            }, 750);
          }

          const dialog = document.querySelector(
            `[data-popup-id="${payload.items[0]?.properties._groupId}"]`
          );
          if (dialog) {
            dialog.close();
            document.body.classList.remove('overflow-hidden');
          }
        }
      }

      async updateSelection(event) {
        if (!this.groupId) return;
        const activeOptions = this.querySelectorAll('[data-option].active');
        const payload = this.preparePayload(activeOptions);
        const currentGroupId = payload?.items[0]?.properties._groupId;
        if (currentGroupId === this.groupId) {
          const dialog = document.querySelector(`[data-popup-id="${this.groupId}"]`);
          if (dialog) {
            dialog.close();
            document.body.classList.remove('overflow-hidden');
          }
          return;
        } else {
          const updatePaylod = this.updatesPayload;
          updatePaylod.sections = payload.sections;
          const request = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify(updatePaylod),
          };
          try {
            const response = await fetch(Theme.routes.cart_update_url, request);
            if (response.ok) {
              this.handleAddToCart(event);
            }
          } catch (error) {
            console.error(error);
          }
        }
      }

      preparePayload(activeOptions) {
        let properties = [
          {
            property: '',
            value: '',
            ref: 'ref="colorProperty"',
          },
          {
            property: '',
            value: '',
            ref: 'ref="doorStyleProperty"',
          },
          {
            property: '',
            value: '',
            ref: 'ref="doorEdgeProfileProperty"',
          },
          {
            property: '',
            value: '',
            ref: 'ref="drawerBoxColorProperty"',
          },
        ];
        const quantity = Number(this.dataset.productQuantity);
        const productCard = this.cabinetConfigurator?.querySelector(
          `product-card[data-product-id="${this.popupId}"]`
        );
        if (productCard) {
          for (let i = 0; i < properties.length; i++) {
            const property = productCard.querySelector(`[${properties[i].ref}]`);
            if (property.value !== '') {
              properties[i].property = property.dataset.propertyName;
              properties[i].value = property.value;
            }
          }
        } else if (this.properties) {
          for (let i = 0; i < this.properties.length; i++) {
            properties[i].property = this.properties[i].property;
            properties[i].value = this.properties[i].value.replace('&quot;', '"');
          }
        }

        const cartItemComponentsSectionIds = [];
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        for (const item of cartItemsComponents) {
          if (item instanceof HTMLElement && item.dataset.sectionId) {
            cartItemComponentsSectionIds.push(item.dataset.sectionId);
          }
        }
        const editSection = document.querySelector('.cabinet-edit-section');
        if (editSection) {
          cartItemComponentsSectionIds.push(editSection.id.replace('shopify-section-', ''));
        }

        const payload = {
          items: [
            {
              id: this.productId,
              quantity: quantity,
              properties: {
                _groupId: '',
              },
            },
          ],
          sections: cartItemComponentsSectionIds.join(','),
        };

        for (let i = 0; i < properties.length; i++) {
          if (properties[i].value !== '') {
            payload.items[0].properties[properties[i].property] = properties[i]?.value;
          }
        }

        activeOptions.forEach((option) => {
          if (option.hasAttribute('data-hinge-side')) {
            payload.items[0].properties[`${option.getAttribute('data-property-name')}`] =
              option.getAttribute('data-hinge-side');
            if (payload.items[0].properties._groupId !== '') {
              payload.items[0].properties._groupId =
                payload.items[0].properties._groupId + `-${option.getAttribute('data-hinge-side')}`;
            } else {
              payload.items[0].properties._groupId = `${this.productId}-${option.getAttribute('data-hinge-side')}`;
            }
          }
          if (option.hasAttribute('data-finished-end')) {
            payload.items[0].properties[`${option.getAttribute('data-property-name')}`] =
              option.getAttribute('data-finished-end');
            if (payload.items[0].properties._groupId !== '') {
              payload.items[0].properties._groupId =
                payload.items[0].properties._groupId +
                `-${option.getAttribute('data-finished-end').replace(' ', '-')}`;
            } else {
              payload.items[0].properties._groupId = `${this.productId}-${option.getAttribute('data-finished-end').replace(' ', '-')}`;
            }

            if (option.getAttribute('data-finish-id')) {
              payload.items[0].properties._groupId =
                payload.items[0].properties._groupId + `-${option.getAttribute('data-finish-id')}`;

              const finishSku = {
                id: option.getAttribute('data-finish-id'),
                quantity: quantity * Number(option.getAttribute('data-finish-quantity')),
                properties: {},
              };
              payload.items.unshift(finishSku);
            }
          }
        });

        if (payload.items.length > 1 && Object.keys(payload.items[1]?.properties).length > 0) {
          payload.items[0].properties = {
            ...payload.items[1]?.properties,
            Cabinet: this.productTitle,
          };
        }

        return payload;
      }

      setPrice(element) {
        if (!this.priceContainer || !element.hasAttribute('data-finish-price')) return;
        const productQuantity = Number(this.dataset.productQuantity);
        const currentPrice = Number(this.priceContainer.dataset.selectedPrice) * productQuantity;
        const elementPrice = Number(element.getAttribute('data-finish-price')) * productQuantity;
        const total = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currency,
        }).format(currentPrice + elementPrice);
        this.priceContainer.innerHTML = total;
      }

      adjustQuantity(element) {
        if (!element.hasAttribute('data-finish-quantity')) return;
        const productQuantity = Number(this.dataset.productQuantity);
        const finishQuantity = Number(element.getAttribute('data-finish-quantity'));
        const quantity = productQuantity + productQuantity * finishQuantity;
        this.quantityContainer.innerHTML = `(${quantity})`;
      }
    }
  );
}

if (!customElements.get('cabinet-configurator-filters')) {
  customElements.define(
    'cabinet-configurator-filters',
    class CabinetConfiguratorFilters extends HTMLElement {
      constructor() {
        super();
        this.filters = this.querySelectorAll('[data-sku-filter]');
        this.cabinetConfigurator = this.closest('cabinet-configurator');
        this.closeButtons = this.querySelectorAll('[data-close-filters-popup]');
        this.filtersCountContainer = this.querySelector('[data-selected-filters]');
        this.resetFilterButtons = this.querySelectorAll('[data-sku-filter-reset]');
        this.clearButton = this.querySelector('[data-clear-sku-filters]');
      }

      connectedCallback() {
        if (this.filters.length === 0) return;
        this.filters.forEach((filter) => {
          filter.addEventListener('change', () => this.selectFilter(filter));
        });

        if (this.clearButton) {
          this.clearButton.addEventListener('click', (event) => this.handleClearAll(event));
        }

        if (this.resetFilterButtons.length > 0) {
          this.resetFilterButtons.forEach((button) =>
            button.addEventListener('click', () => this.resetFilter(button))
          );
        }

        if (this.closeButtons.length > 0) {
          this.closeButtons.forEach((button) =>
            button.addEventListener('click', () => {
              this.classList.remove('active');
              this.cabinetConfigurator.classList.remove('filters-opened');
              document.body.classList.remove('overflow-hidden');
            })
          );
        }
      }

      selectFilter(filter) {
        const activeFilters = this.querySelectorAll('[data-sku-filter]:checked');
        this.filtersCountContainer.innerHTML = `(${activeFilters.length})`;
        this.handleApplyFilters(filter);
      }

      handleApplyFilters(filter) {
        let url = new URL(window.location.href);
        if (this.cabinetConfigurator && this.cabinetConfigurator.currentFilterUrl != '') {
          url = new URL(this.cabinetConfigurator.currentFilterUrl);
        }
        if (filter.checked) {
          const filterParamName = filter.name;
          const filterValue = filter.value;
          const currentValues = url.searchParams.getAll(filterParamName);
          if (!currentValues.includes(filterValue)) {
            url.searchParams.append(filterParamName, filterValue);
          }

          this.cabinetConfigurator.dataset.filterUrl = url.toString();
          this.filters.forEach((filter) => filter.parentNode.classList.add('busy'));
          this.applyFilters(url);
        } else {
          this.resetFilter(filter);
        }
      }

      async applyFilters(url) {
        const response = await fetch(url.toString());
        const result = await response.text();
        const HTML = new DOMParser().parseFromString(result, 'text/html');
        const elementsToRerender =
          this.cabinetConfigurator.querySelectorAll('[data-should-rerender]');
        elementsToRerender.forEach((element) => {
          const rerenderValue = element.dataset.shouldRerender;
          const newElement = HTML.querySelector(`[data-should-rerender="${rerenderValue}"]`);
          if (newElement) {
            element.innerHTML = newElement.innerHTML;
          }
        });
        document.dispatchEvent(new CustomEvent('filters::updated'));
      }

      updateMainUrl(url) {
        if (this.filters.length === 0) return;
        this.filters.forEach((filter) => {
          const filterParamName = filter.name;
          url.searchParams.delete(filterParamName);
        });
        url.searchParams.delete('page');

        this.cabinetConfigurator.dataset.filterUrl = url.toString();
      }

      resetFilter(filter) {
        let url = new URL(window.location.href);
        if (this.cabinetConfigurator && this.cabinetConfigurator.currentFilterUrl != '') {
          url = new URL(this.cabinetConfigurator.currentFilterUrl);
        }
        const filterParamName = filter.dataset.skuFilterReset;
        const filterValue = filter.dataset.skuFilterValue;
        const currentValues = url.searchParams.getAll(filterParamName);
        const values = currentValues.filter((value) => value !== filterValue);
        url.searchParams.delete(filterParamName);
        values.forEach((value) => url.searchParams.append(filterParamName, value));
        url.searchParams.delete('page');
        this.cabinetConfigurator.dataset.filterUrl = url.toString();
        this.applyFilters(url);
      }

      handleClearAll(event) {
        event.preventDefault();
        let url = new URL(window.location.href);
        if (this.cabinetConfigurator && this.cabinetConfigurator.currentFilterUrl != '') {
          url = new URL(this.cabinetConfigurator.currentFilterUrl);
        }
        this.updateMainUrl(url);
        const urlToApply = this.cabinetConfigurator.dataset.filterUrl;
        this.applyFilters(urlToApply);
      }
    }
  );
}

if (!customElements.get('sroll-list')) {
  customElements.define(
    'sroll-list',
    class SrollList extends HTMLElement {
      connectedCallback() {
        this.container = this.querySelector('.swiper');
        this.leftArrow = this.querySelector('[data-arrow-left]');
        this.rightArrow = this.querySelector('[data-arrow-right]');
        if (window.innerWidth < 990) return;
        this.initSlider();
      }

      initSlider() {
        const options = {
          observer: true,
          observeParents: true,
          slidesPerMove: 1,
          grabCursor: true,
          spaceBetween: 8,
          freeMode: true,
          slidesPerView: 'auto',
          watchOverflow: true,
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: this.rightArrow,
            prevEl: this.leftArrow,
          },
        };

        new Swiper(this.container, options);
      }
    }
  );
}

if (!customElements.get('edit-configuration')) {
  customElements.define(
    'edit-configuration',
    class EditConfiguration extends HTMLElement {
      constructor() {
        super();
        this.editButton = this.querySelector('[data-edit-configuration]');
        if (!this.editButton) return;
      }

      connectedCallback() {
        this.editButton.addEventListener('click', (event) => this.openEditPopup(event));
      }

      openEditPopup(event) {
        event.preventDefault();
        event.stopPropagation();
        const popupId = this.editButton.dataset.editConfiguration;
        const editPopup = document.querySelector(`[data-popup-id="${popupId}"]`);
        if (!editPopup) return;
        editPopup.showModal();
        document.body.classList.add('overflow-hidden');
      }
    }
  );
}
